import React from 'react';
import {
	Typography,
	Card,
	CardMedia,
	Stack,
	Link,
	Container,
	Grid,
	Chip,
	Box,
	useTheme,
} from '@mui/material';
import { minimalLabelTheme } from '@/app/theme';
import { SignInButton } from '@/components/buttons/SignInButton';
import AIRyan from '@/assets/images/ai-ryan.png';
import crmLogo from '@/assets/images/folioCRM.png';
import darkCrmLogo from '@/assets/images/folioCRM_dark_matched.png';
import { IS_DEV, IS_PRE } from '@/utils/environment';

const LoginPage = () => {
	const theme = useTheme();
	const logo = theme.palette.mode === 'dark' ? crmLogo : darkCrmLogo;

	return (
		<Container>
			<Grid
				container
				spacing={2}
				style={{ height: '100vh', overflow: 'hidden', display: 'flex' }}
			>
				<Grid size={6} style={{ height: '100%' }}>
					<Card sx={{ width: '100%', height: '100%', borderRadius: 0 }}>
						<CardMedia
							component='img'
							height='100%'
							width='100%'
							src={AIRyan}
							alt='Support staff'
							sx={{ objectFit: 'cover' }}
						/>
					</Card>
				</Grid>
				<Grid size={6} container justifyContent='center' alignItems='center'>
					<Stack direction='column'>
						<Card sx={{ padding: 8 }}>
							<Stack direction='row' alignItems='center' spacing={1}>
								<Box
									component='img'
									src={logo}
									alt='Folio CRM'
									sx={{ height: 30, width: 'auto' }}
								/>
								{IS_DEV && <Chip label='DEV' color='primary' size='small' />}
								{IS_PRE && <Chip label='PRE' color='secondary' size='small' />}
							</Stack>
							<Typography sx={{ mt: 1, mb: 4 }}>Log in below</Typography>
							<SignInButton />
						</Card>
						<Typography sx={{ ...minimalLabelTheme, marginTop: 1 }}>
							Need help? Email{' '}
							<span>
								<Link
									href={'mailto:support@folio.insure'}
									target='_blank'
									rel='noopener noreferrer'
								>
									support@folio.insure
								</Link>
							</span>{' '}
							for assistance.
						</Typography>
					</Stack>
				</Grid>
			</Grid>
		</Container>
	);
};

LoginPage.displayName = 'LoginPage';

export default LoginPage;
